import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../../Context/ConfigContext';
import Swal from 'sweetalert2';
import { FiX } from "react-icons/fi";
import "./SearchBar.css"
import axios from "axios";
import { axiosGet } from '../../Apis/axiosMethods';
import Config from '../../appConfig';
import { default_image } from '../../Imgaes';

const SearchBar = () => {
  const { t } = useTranslation();
  const { gdcURL, apiB2BURL, handleCloseSearchInputTip, searchInputTip, modalZIndex, setModalZIndex } = useContext(ConfigContext);
  const [keyword, setKeyword] = useState('');
  const [searchResDisplay, setSearchResDisplay] = useState(false);
  const [SearchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const navigate = useNavigate();
  const divRef = useRef(null);
  const lang = localStorage.getItem('lang');
  const dir = localStorage.getItem('dir');

  const [showOverlay, setShowOverlay] = useState(false);


  const [showStatementModal, setShowStatementModal] = useState(false);


  useEffect(() => {
    const fetchSearchResults = async () => {
      if (!keyword.trim()) {
        setSearchResDisplay(false);
        setHighlightedIndex(-1);
        setSearchResults([]);
        return;
      }

      try {
        setLoading(true);

        const response = await axiosGet(`/Parts/GetSearchParts`, {
          keyword: keyword.trim().replace(/[^a-zA-Z0-9]/g, ""),
          pc_id: localStorage.getItem("pc_id"),
          lang: lang
        });

        const docs = response.data.response.docs;

        const uniqueDocs = Array.from(
          new Map(
            docs.map(doc => [doc.SEARCH_KEY_WORDS.join("|"), doc])
          ).values()
        );

        setSearchResults(uniqueDocs);
        setSearchResDisplay(true);
        setHighlightedIndex(0);

      } catch (error) {
        console.error("Search Error:", error);

        setSearchResults([]);
        setSearchResDisplay(false);
        setHighlightedIndex(-1);

      } finally {
        setLoading(false);
      }
    };

    fetchSearchResults();
  }, [keyword]);

  const handleChange = (e) => {
    const value = e.target.value;
    setKeyword(value);
    setSearchResDisplay(true);
    handleCloseSearchInputTip()
  };

  const navigateHandle = (part) => {
    setSearchResDisplay(false);

    const productName = Array.isArray(part?.ART_PRODUCT_NAME)
      ? part.ART_PRODUCT_NAME[0]
      : part?.ART_PRODUCT_NAME || "";

    const slug = productName
      .trim()
      .replace(/,/g, "")
      .replace(/\//g, "-")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

    // SEARCH_TYPE available
    if (part?.SEARCH_TYPE === "IAMNumber") {
      navigate(
        `/Spare-Parts/Details/${slug}-${part.ART_SEARCH_NUMBER}-${part.SUP_ID}`
      );
      return;
    }

    if (part?.SEARCH_TYPE === "OENumber") {
      navigate(
        `/Spare-Parts/OEM/${slug}-${part.ART_SEARCH_NUMBER}`
      );
      return;
    }

    if (part?.SEARCH_TYPE === "PRODUCTS") {
      navigate(part.SEARCH_URL);
      return;
    }

    // SEARCH_TYPE not available
    if (!part?.SEARCH_TYPE) {
      // IAM Product
      if (part?.SUP_ID && part?.ART_SEARCH_NUMBER) {
        navigate(
          `/Spare-Parts/Details/${slug}-${part.ART_SEARCH_NUMBER}-${part.SUP_ID}`
        );
        return;
      }

      // OE Product
      if (part?.ART_SEARCH_NUMBER) {
        navigate(
          `/Spare-Parts/OEM/${slug}-${part.ART_SEARCH_NUMBER}`
        );
        return;
      }

      // Category
      if (part?.SEARCH_URL) {
        navigate(
          localStorage.getItem("pc_id")
            ? `/Spare-Parts/${part.SEARCH_URL}`
            : `/Spare-Parts/Spare-Parts-nocar/${part.STR_ID}/${part.SEARCH_URL}`
        );
      }
    }
  };




  const onNavigateBy = () => {
    if (!loading && SearchResults.length === 0) {
      Swal.fire({
        title: t('error'),
        text: t('no_result'),
        icon: "error",
        confirmButtonText: "Okay",
      });
    } else {
      setSearchResDisplay(false);
      if (SearchResults.length > 0) {
        const part = SearchResults[0];
        document.getElementById("keyword_input").value = part.SEARCH_KEY_WORDS.join(" ");
        navigateHandle(part);
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setHighlightedIndex((prev) =>
        prev < SearchResults.length - 1 ? prev + 1 : 0
      );
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : SearchResults.length - 1
      );
    } else if (event.key === 'Enter') {
      event.preventDefault();
      if (highlightedIndex >= 0 && highlightedIndex < SearchResults.length) {
        navigateHandle(SearchResults[highlightedIndex]);
        setSearchResDisplay(false);
      } else {
        onNavigateBy();
      }
    }
  };

  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      setSearchResDisplay(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // GetImage function remains unmodified
  const GetImage = (part) => {
    if (part.SEARCH_TYPE === 'CATEGORY') {
      return `${gdcURL}/category-images/600x600/${part.STR_ID}`;
    }
    else if (part.SEARCH_TYPE === 'IAMNumber') {
      return `${Config.api}/Parts/GetAFMImages?part_number=${encodeURIComponent(part?.ART_SEARCH_NUMBER || '')}&sup_id=${part?.SUP_ID}`;
    }
    else if (part?.SEARCH_TYPE === 'OENumber') {
      return `${Config.api}/Parts/GetOEImages?part_number=${encodeURIComponent(part?.ART_SEARCH_NUMBER || '')}`;
    }
    else if (part.SEARCH_TYPE === 'PRODUCTS') {
      return `${gdcURL}/product-images/600x600/${part.ART_ID}`;
    }

    return `${default_image}`;
  };

  const PartImageCell = ({ item }) => {
    const [imageUrl, setImageUrl] = useState(GetImage(item));

    useEffect(() => {
      const url = GetImage(item);
      const image = new Image();

      setImageUrl(url);

      image.onload = () => setImageUrl(url);
      image.onerror = () => setImageUrl(default_image);

      image.src = url;

      return () => {
        image.onload = null;
        image.onerror = null;
      };
    }, [item]);

    return (
      <td
        width={40}
        style={{
          backgroundImage: `url("${imageUrl}")`,
          backgroundSize: '90%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      />
    );
  };

  const clearSearch = () => {
    setKeyword('');
    setSearchResults([]);
    setSearchResDisplay(false);
    setHighlightedIndex(-1);

    const input = document.getElementById('keyword_input');
    if (input) {
      input.value = '';
      input.focus();
    }
  };



  const getGroupedResults = () => {
    const seen = new Set();
    const finalResults = [];

    SearchResults.forEach((item) => {
      if (item.SEARCH_TYPE === "OENumber") {

        const keywords = Array.isArray(item.SEARCH_KEY_WORDS)
          ? item.SEARCH_KEY_WORDS
          : [];

        const rawOEM = keywords.find(val =>
          /^[A-Z0-9]{6,}$/i.test(val)
        );

        if (!rawOEM) {
          finalResults.push(item);
          return;
        }

        const normalizedOEM = rawOEM.replace(/^[A-Z]+/, "");

        if (seen.has(normalizedOEM)) return;

        seen.add(normalizedOEM);
        finalResults.push(item);

      } else {
        finalResults.push(item);
      }
    });

    return finalResults;
  };

  const groupedResults = getGroupedResults();

  const getOEMNumber = (item) => {
    if (!Array.isArray(item?.SEARCH_KEY_WORDS)) return "";

    return (
      item.SEARCH_KEY_WORDS.find(val =>
        /^[A-Z0-9]{6,}$/i.test(val)
      ) || ""
    );
  };

  return (
    <>

      {showOverlay && (
        <div
          onClick={() => {
            setShowOverlay(false);
            setSearchResDisplay(false);
          }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 9999999
          }}
        />
      )}

      <div
        ref={divRef}
        style={{
          direction: dir,
          width: '541px',
          position: "relative",
          zIndex: modalZIndex ? 1001 : 999999999,
        }}
        className="header-icon header-search header-search-inline header-search-category mt-0"
      >
        {searchInputTip && (
          <div className="custom-hint-wrapper">
            <div className="custom-hint-box">
              <span className="custom-hint-text">
                Search by OE number or Aftermarket number.
              </span>

              <FiX
                onClick={handleCloseSearchInputTip}
                style={{ cursor: "pointer" }}
              />

            </div>

            <div className="custom-hint-arrow" />
          </div>
        )}

        <div className="input-group position-relative">
          <input
            onKeyDown={handleKeyDown}
            onChange={handleChange}
            onFocus={() => {
              setShowOverlay(true)
              handleCloseSearchInputTip()
              setModalZIndex(false)
            }
            }
            onBlur={() => setShowOverlay(false)}
            type="text"
            className="form-control"
            style={{ borderRadius: '0px', zIndex: 999 }}
            placeholder={t("enter_part_number_name")}
            aria-label={t("enter_part_number_name")}
            aria-describedby="basic-addon2"
            id="keyword_input"
            autoComplete='off'
          />
          <div className="input-group-append">
            {keyword && (
              <span
                onClick={clearSearch}
                className="input-group-text"
                style={{
                  backgroundColor: '#f4f4f4',
                  color: '#000',
                  cursor: 'pointer'
                }}
              >
                <FiX />
              </span>
            )}
            <span
              style={{
                backgroundColor: '#f4f4f4',
                borderTop: '#f4f4f4',
                borderBottom: '#f4f4f4',
                borderRight: '#f4f4f4',
                color: '#a8a8a8',
                cursor: 'pointer'
              }}
              className="input-group-text"
              onClick={() => setShowStatementModal(true)}
            >
              {t('example')}
              {" \u00A0  "}{" "}
              <i style={{ fontSize: '12px' }}
                className={`fas fa-info-circle`}></i>
            </span>

            <button onClick={() => onNavigateBy()} style={{
              paddingTop: 'unset',
              paddingBottom: 'unset',
              borderRadius: '0px',
              marginLeft: '8px',
              marginRight: dir === 'rtl' ? '8px' : '',
              width: '100px',
              transition: 'background-color 0.3s ease',
            }} className="btn btn-primary" type="button">{t("search")} </button>
          </div>
        </div>


        {searchResDisplay && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              width: '100%',
              display: "block",
              background: "rgba(0,0,0,0.3)",
              zIndex: 9999999999,
            }}
          >
            {/* 🔹 Overlay behind table */}
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: '#fff',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                zIndex: 0
              }}
            />

            {/* 🔹 Search Result Table */}
            <div style={{ position: 'relative', zIndex: 1 }}>
              {!loading && SearchResults?.length === 0 && (
                <div className="mt-2 text-danger text-center">
                  {t('no_result')}
                </div>
              )}

              {!loading && (
                <table className="table mb-0">
                  {groupedResults.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        cursor: 'pointer', zIndex: 999999
                      }}
                      onClick={() => navigateHandle(item)}
                    >
                      {/* <td
                        width={40}
                        style={{
                          backgroundImage: `url(${GetImage(item)})`,
                          backgroundSize: '90%',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center'
                        }}
                      /> */}
                      <PartImageCell item={item} />

                      <td>
                        {item.SEARCH_TYPE === 'OENumber'
                          ? `OEN ${getOEMNumber(item)}`
                          : item.SEARCH_KEY_WORDS?.join(" ")
                        }
                      </td>
                    </tr>
                  ))}
                </table>
              )}
            </div>
          </div>
        )}



      </div >



      {showStatementModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.3)",
            zIndex: 9999999999,
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0
          }}
          tabIndex={-1}
          role="dialog"
          onClick={() => setShowStatementModal(false)}
        >
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ maxWidth: 900, margin: "5% auto", zIndex: 100000000 }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" onClick={() => setShowStatementModal(false)}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {
                  lang === 'ar' ?
                    <>
                      <p style={{ fontSize: 'x-large' }}>5,800,000 قطعة غيار – ابحث عن الجزء المناسب لسيارتك <br />
                        ابحث عن قطع الغيار باستخدام التركيبات التالية:</p><table className='table' style={{ fontSize: 'medium' }}>
                        <tbody>
                          <tr><th>نوع البحث</th><th>مثال</th></tr>
                          <tr><td>قطعة غيار</td><td>شمعات الاحتراق</td></tr>
                          <tr><td>قطعة غيار + مصنع القطعة</td><td>شمعات الاحتراق RIDEX</td></tr>
                          <tr><td>قطعة غيار + ماركة السيارة</td><td>شمعات الاحتراق CITROËN</td></tr>
                          <tr><td>قطعة غيار + رقم الصنف</td><td>شمعات الاحتراق 686S0071</td></tr>
                          <tr><td>رقم الصنف</td><td>13447</td></tr>
                          <tr><td>رقم الصنف + مصنع القطعة</td><td>SKSP-1990029 STARK</td></tr>
                        </tbody>
                      </table>
                    </>
                    :
                    <>
                      <p style={{ fontSize: 'x-large' }}>5,800,000 auto parts – find the right spare part for your car <br />
                        Search for spare parts using the following combinations:</p><table className='table' style={{ fontSize: 'medium' }}>
                        <tbody>
                          <tr><th>Search type</th><th>Example</th></tr>
                          <tr><td>Car part</td><td>Spark plugs</td></tr>
                          <tr><td>Car part + car part manufacturer</td><td>Spark plugs RIDEX</td></tr>
                          <tr><td>Car part + car brand</td><td>Spark plugs CITROËN</td></tr>
                          <tr><td>Car part + item number</td><td>Spark plugs 686S0071</td></tr>
                          <tr><td>Item number</td><td>13447</td></tr>
                          <tr><td>Item number + car part manufacturer</td><td>SKSP-1990029 STARK</td></tr>
                        </tbody>
                      </table>
                    </>
                }
              </div>
            </div>
          </div>
        </div>
      )
      }
    </>
  );
};

export default SearchBar;